import { render, staticRenderFns } from "./GroupDetailResult.vue?vue&type=template&id=619c1413&scoped=true"
import script from "./GroupDetailResult.vue?vue&type=script&lang=js"
export * from "./GroupDetailResult.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailResult.vue?vue&type=style&index=0&id=619c1413&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c1413",
  null
  
)

export default component.exports